import { Component, OnInit, ViewChild } from '@angular/core';
import { ListCustData } from '../lost-customer/listCustData';
import { VisitListCustData } from '../lost-customer/visitListCustData';
import { ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CommonService } from '../../core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatPaginator, MatSort, MatSelect } from '@angular/material';
import { DatePipe } from '@angular/common';
import { FilterPipePipe } from '../../pipes/filter-pipe.pipe';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-lost-customer',
  templateUrl: './lost-customer.component.html',
  styleUrls: ['./lost-customer.component.scss'],
  providers: [FilterPipePipe]
})
export class LostCustomerComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator,{static:false}) paginator: MatPaginator;
  @ViewChild('filterSelect', { static: true }) filterSelect: MatSelect;

  callsToBeMade: number = 0;
  visitCallsToBeMade: number = 0;
  pageSize: number;
  visitPageSize: number;
  callsMade: number = 0;
  visitCallsMade: number = 0;
  callToggleStatus: boolean = true;
  visitCallToggleStatus: boolean = true;
  displayedColumns: string[] = [
    'customerName',
    'callType',
    'callStatus',
    'leadGenerationDate',
    'callTime',
    'creInput',
    'followUpTime',
    'remarks'
  ];
  displayedVisitColumns: string[] = [
    'customerName',
    'callType',
    'callStatus',
    'leadGenerationDate',
    'visitingDate',
    'callTime',
    'creInput',
    'disengageReason',
    'proposal',
    'remarks'
  ];
  dataSource: any;
  visitDataSource: any;
  spinner: boolean;
  customersToBeCalled: string;
  callsMade1: string;
  visitCustomersToBeCalled: string;
  visitCallsMade1: string;
  filterMap = new Map();
  visitFilterMap = new Map();
  uniqueCallType = new Set<string>();
  uniqueCallState = new Set<string>();
  filteredDataSource: any;
  filteredVisitDataSource: any;
  callFlag: any;
  callStats: any = {};
  userId: string;
  selectedCallTypeValues: string[] = [];
  selectedCallStatusValues: string[] = [];
  callListType: any[] = [
    { value: 'Call List', viewValue: 'Call List' },
    { value: 'Visit Call List', viewValue: 'Visit Call List' }];
  selectedCallListType: any;
  showVisitList: boolean;

  constructor(private commonService: CommonService, private router: Router, public dialog: MatDialog,
    private toastr: ToastrService, private datePipe: DatePipe, private changeDetectorRefs: ChangeDetectorRef,
    private filterPipePipe: FilterPipePipe, private fb: FormBuilder) { }

  ngOnInit() {
    if (localStorage.getItem('userId') == null || localStorage.getItem('userId') == undefined) {
      this.router.navigate(['login']);
    }
    this.userId = localStorage.getItem('userId');

    if (localStorage.getItem('selectedCallListType') != null || localStorage.getItem('selectedCallListType') != undefined) {
      let selectedCallListType = JSON.parse(localStorage.getItem('selectedCallListType'));
      this.selectedCallListType = selectedCallListType;
    }

    if (localStorage.getItem('selectedCallTypeValues') != null || localStorage.getItem('selectedCallTypeValues') != undefined) {
      let selectedCallTypeValues = JSON.parse(localStorage.getItem('selectedCallTypeValues'));
      this.selectedCallTypeValues = selectedCallTypeValues;
    }

    if (localStorage.getItem('selectedCallStatusValues') != null || localStorage.getItem('selectedCallStatusValues') != undefined) {
      let selectedCallStatusValues = JSON.parse(localStorage.getItem('selectedCallStatusValues'));
      this.selectedCallStatusValues = selectedCallStatusValues;
    }

    // if (localStorage.getItem('callListPageSize') != null || localStorage.getItem('callListPageSize') != undefined) {
    //   let pagesize = Number(localStorage.getItem('callListPageSize'));
    //   this.pageSize = (pagesize && pagesize != NaN) ? pagesize : 50;
    // } else {
    //   this.pageSize = 50;
    // }

    // if (localStorage.getItem('visitCallListPageSize') != null || localStorage.getItem('visitCallListPageSize') != undefined) {
    //   let pagesize = Number(localStorage.getItem('visitCallListPageSize'));
    //   this.visitPageSize = (pagesize && pagesize != NaN) ? pagesize : 50;
    // } else {
    //   this.visitPageSize = 50;
    // }

    if (localStorage.getItem('workshops') == null || localStorage.getItem('workshops') == undefined) {
      this.getWorkshopDetails();
    }

    this.getCreStats();
    //console.log("selectedCallListType : ",this.selectedCallListType);
    this.getCallList();
  }

  /**
  * Name: setPageData
  * purpose: To set pagesize for table
  */
  

  /**
  * Name: setVisitPageData
  * purpose: To set pagesize for table
  */
  setVisitPageData(event) {
    let size = event.visitPageSize.toString();
    localStorage.setItem('visitCallListPageSize', size);
  }

  /**
  * Name: getWorkshopDetails
  * purpose: To get CRE assigned workshop details
  */
  getWorkshopDetails() {
    this.commonService.getWorkshopDetails(this.userId).subscribe(res => {
      if (res['responseCode'] == 0) {
        localStorage.setItem('workshops', JSON.stringify(res['responseData']));
      } else {
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  /**
  * Name: prepairCallList
  * purpose: To get calllist details
  * @param {string} flag - type of call
  */
  prepairCallList(flag: string): void {
    this.spinner = true;
    this.commonService.lostCustomerCallList(this.userId, flag)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          if (flag == 'Y') {
            this.callFlag = flag;
            this.callToggleStatus = true;
          } else {
            this.callFlag = flag;
            this.callToggleStatus = false;
          }
          if (res['responseData'].length) {
            res['responseData'].forEach(data => {

              // if ((data.custType).toLowerCase() == "lost") {
              //   let changeName = data.customerName.split(" - L")[0];
              //   data.customerName = changeName;
              // }
              let inboundCustomer = data.customerName.includes("- I");
              let stringPosition = data.customerName.length;
              let lostString = data.customerName[stringPosition - 3] + data.customerName[stringPosition - 2] + data.customerName[stringPosition - 1]
              if (inboundCustomer && lostString == "- I") {
                let changeName = data.customerName.split(" - I")[0];
                data.customerName = changeName;
                // data.isInboundCall = true;
              }
            });
          }
          this.callsToBeMade = res['responseData'].length;
          //init data table and shorting
          this.dataSource = new MatTableDataSource<ListCustData>(res['responseData']);
          // this.sort.direction = '';
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = (data, header) => data[header];
          this.dataSource.paginator = this.paginator;
          this.filterData();
          if ((!this.selectedCallTypeValues || this.selectedCallTypeValues.length == 0)
            && (!this.selectedCallStatusValues || this.selectedCallStatusValues.length == 0)) {
            //init filtered table and shorting
            this.filteredDataSource = new MatTableDataSource<ListCustData>(res['responseData']);
            // this.sort.direction = '';
            this.filteredDataSource.sort = this.sort;
            this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
            this.filteredDataSource.paginator = this.paginator;
          }
          // this.callsMadeCalculate(res['responseData']);
          this.LostCallListinfo();
          this.spinner = false;
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
          this.callToggleStatus = true;
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
        this.callToggleStatus = true;
      });
  }

  /**
  * Name: getCallList
  * purpose: To get calllist details
  * @param {string} flag - type of call
  */
  getCallList() {
    if(this.selectedCallListType == 'Visit Call List') {
      this.selectedCallListType = 'Visit Call List';
      this.showVisitList = true;
      this.prepairVisitCallList('N');
      localStorage.setItem('selectedCallListType',JSON.stringify(this.selectedCallListType));
    } else {
      this.selectedCallListType = 'Call List';
      this.showVisitList = false;
      this.prepairCallList('Y');
      localStorage.setItem('selectedCallListType',JSON.stringify(this.selectedCallListType));
    }
  }

  /**
  * Name: prepairVisitCallList
  * purpose: To get visit calllist details
  * @param {string} flag - type of call
  */
  prepairVisitCallList(flag: string): void {
    this.spinner = true;
    // this.visitDataSource = '';
    // this.filteredVisitDataSource = '';
    this.commonService.lostCustomerVisitCallList(this.userId, flag).subscribe(res => {
      if (res['responseCode'] == 0 && res['responseData'] != undefined) {
        if (flag == 'N') {
          this.callFlag = flag;
          this.visitCallToggleStatus = true;
        } else {
          this.callFlag = flag;
          this.visitCallToggleStatus = false;
        }
        this.visitCallsToBeMade = res['responseData'].length;
        //init data table and shorting
        this.visitDataSource = new MatTableDataSource<VisitListCustData>(res['responseData']);
        // this.sort.direction = '';
        this.visitDataSource.sort = this.sort;
        this.visitDataSource.sortingDataAccessor = (data, header) => data[header];
        this.visitDataSource.paginator = this.paginator;
        this.filterData();
        if ((!this.selectedCallTypeValues || this.selectedCallTypeValues.length == 0)
          && (!this.selectedCallStatusValues || this.selectedCallStatusValues.length == 0)) {
          //init filtered table and shorting
          this.filteredVisitDataSource = new MatTableDataSource<VisitListCustData>(res['responseData']);
          // this.sort.direction = '';
          this.filteredVisitDataSource.sort = this.sort;
          this.filteredVisitDataSource.sortingDataAccessor = (data, header) => data[header];
          this.filteredVisitDataSource.paginator = this.paginator;
        }
        // this.callsMadeCalculate(res['responseData']);
        this.VisitCallListinfo();
        this.spinner = false;
      } else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
        this.visitCallToggleStatus = true;
      }
    }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
        this.visitCallToggleStatus = true;
    });
  }

  // openVisit(){
  //   localStorage.setItem('navOption','Visit')
  //   this.router.navigate(['visiting-list']);
  // }

  /**
    * Name: callListinfo
    * purpose: To get call count info
    */
  LostCallListinfo(): void {
    this.spinner = true;
    this.commonService.lostCallListinfo(this.userId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.customersToBeCalled = res['responseData']['customersToBeCalled'];
          this.callsMade1 = res['responseData']['callsMade'];
          this.spinner = false;
        } else {
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
    * Name: callListinfo
    * purpose: To get call count info
    */
   VisitCallListinfo(): void {
    //this.spinner = true;
    this.commonService.visitCallListinfo(this.userId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.visitCustomersToBeCalled = res['responseData']['customersToBeContacted'];
          this.visitCallsMade1 = res['responseData']['contactMade'];
          //this.spinner = false;
        } else {
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        //this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
        //...
      });
  }

  /**
    * Name: getCreStats
    * purpose: To get call count info
    */
  getCreStats(): void {
    //this.spinner = true;
    this.commonService.getLostCreCallStats(this.userId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          //this.spinner = false;
          this.callStats = res['responseData'][0];
        } else {
          //this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        //this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
  * Name: callsMadeCalculate
  * purpose: To get call made count
  * @param {Array} callsToBeMade - list of calls
  */
  callsMadeCalculate(callsToBeMade: any) {
    this.callsMade = 0;
    callsToBeMade.forEach(element => {
      let currentDate = "" + this.datePipe.transform(new Date(), "yyyy-MM-dd");
      let reqDate = this.datePipe.transform((element.callTime), "yyyy-MM-dd");
      if (currentDate == reqDate) {
        this.callsMade++;
      }
    });
  }

  /**
  * Name: selectCustomer
  * purpose: To select customer for details
  * @param {Object} row - selected customer details
  */
  selectCustomer(row: ListCustData): void {
    localStorage.setItem('customerId', row.customerId);
    // localStorage.setItem('custNotification', row.serviceType + ", " + row.callStatusDesc);
    localStorage.setItem("customerData", JSON.stringify(row));
    this.router.navigate(['lost-customer360']);
  }

  /**
   * Name: filterData
   * purpose: To filter call list data
   */
  filterData(): void {
    if(this.selectedCallListType == 'Call List') {
      this.dataSource.filteredData.forEach(element => {
        this.uniqueCallState.add(element.callStatus);
        this.uniqueCallType.add(element.callType);
      });
    } else {
      this.visitDataSource.filteredData.forEach(element => {
        this.uniqueCallState.add(element.callStatus);
        this.uniqueCallType.add(element.callType);
      });
    }

    if ((this.selectedCallTypeValues != null && this.selectedCallTypeValues.length != 0)
    || (this.selectedCallStatusValues != null && this.selectedCallStatusValues.length != 0)) {
      this.applyfilter();
    }
  }

  /**
   * Name: applyfilter
   * purpose: To apply filter on call list data
   */
  applyfilter(): void {
    let key = '';
    this.filterMap = new Map();
    this.visitFilterMap = new Map();
    if(this.selectedCallListType == 'Call List') {
      this.filteredDataSource = this.dataSource;
    } else {
      this.filteredVisitDataSource = this.visitDataSource
    }

    if (this.selectedCallTypeValues != null && this.selectedCallTypeValues.length != 0) {
      key = "callType";
      if(this.selectedCallListType == "Call List") {
        this.filterMap.set(key, this.selectedCallTypeValues);
        this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
      } else {
        this.visitFilterMap.set(key, this.selectedCallTypeValues)
        this.filteredVisitDataSource = new MatTableDataSource<VisitListCustData>(this.filterPipePipe.transform(this.filteredVisitDataSource.filteredData, this.visitFilterMap));
      }
    }

    if (this.selectedCallStatusValues != null && this.selectedCallStatusValues.length != 0) {
      key = "callStatus";
      if(this.selectedCallListType == "Call List") {
        this.filterMap.set(key, this.selectedCallStatusValues);
        this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
      } else {
        this.visitFilterMap.set(key, this.selectedCallStatusValues);
        this.filteredVisitDataSource = new MatTableDataSource<VisitListCustData>(this.filterPipePipe.transform(this.filteredVisitDataSource.filteredData, this.visitFilterMap));
      }
    }

    if(this.selectedCallListType == "Call List") {
      this.callsToBeMade = this.filteredDataSource.filteredData.length;
      // this.sort.direction = '';
      this.filteredDataSource.sort = this.sort;
      this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
      this.filteredDataSource.paginator = this.paginator;
    } else {
      this.visitCallsToBeMade = this.filteredVisitDataSource.filteredData.length;
      // this.sort.direction = '';
      this.filteredVisitDataSource.sort = this.sort;
      this.filteredVisitDataSource.sortingDataAccessor = (data, header) => data[header];
      this.filteredVisitDataSource.paginator = this.paginator;
    }


    localStorage.setItem('selectedCallTypeValues',JSON.stringify(this.selectedCallTypeValues));
    localStorage.setItem('selectedCallStatusValues',JSON.stringify(this.selectedCallStatusValues));
    localStorage.setItem('selectedCallListType',JSON.stringify(this.selectedCallListType));
  }

  /**
   * Name: searchfilter
   * purpose: To apply filter on call list data
   */
  searchfilter(filterValue: string): void {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    if(this.selectedCallListType == "Call List") {
      this.filteredDataSource.filter = filterValue;
    } else {
      this.filteredVisitDataSource.filter = filterValue;
    }
  }

  /**
   * Name: clearFilter
   * purpose: To clear filter
   */
  clearFilter(): void {
    this.filterMap.clear();
    this.visitFilterMap.clear();
    this.selectedCallTypeValues = null;
    this.selectedCallStatusValues = null;
    if(this.selectedCallListType == "Call List") {
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.dataSource.filteredData, this.filterMap));
    this.callsToBeMade = this.filteredDataSource.filteredData.length;
    // this.sort.direction = '';
    this.filteredDataSource.sort = this.sort;
    this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
    this.filteredDataSource.paginator = this.paginator;
    } else {
      this.filteredVisitDataSource = new MatTableDataSource<VisitListCustData>(this.filterPipePipe.transform(this.visitDataSource.filteredData, this.visitFilterMap));
    this.visitCallsToBeMade = this.filteredVisitDataSource.filteredData.length;
    // this.sort.direction = '';
    this.filteredVisitDataSource.sort = this.sort;
    this.filteredVisitDataSource.sortingDataAccessor = (data, header) => data[header];
    this.filteredVisitDataSource.paginator = this.paginator;
    }

    localStorage.removeItem('selectedCallTypeValues');
    localStorage.removeItem('selectedCallStatusValues');
  }

  /**
   * Name: changeColor
   * purpose: To change followup time color
   */
  changeColor(followUp: any): String {
    let currentTime = this.datePipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss ");

    if (followUp != null && followUp != undefined && followUp != "") {
      let followUpDateTime = this.datePipe.transform(followUp, "yyyy-MM-dd HH:mm:ss");
      if ((new Date(currentTime)).getTime() > (new Date(followUpDateTime).getTime())) {
        return "red";
      }
    }
  }

  /**
   * Name: activeButton
   * purpose: To activat apply button
   */
  activeButton(): boolean {
    let flag = false;
    if (this.selectedCallTypeValues != null && this.selectedCallTypeValues.length != 0) {
      flag = true;
    } else if (this.selectedCallStatusValues != null && this.selectedCallStatusValues.length != 0) {
      flag = true;
    }
    return flag;
  }

}
